import React, { useRef, useState } from "react";
import Button from "../ui/Button";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Label from "../ui/Label";
import TextArea from "../ui/TextArea";
import { apiCall } from "../utils/Api";

export default function BugReport({ returnLocation, callback = () => { }, }) {
    const [text, setText] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const pending = useRef(false);

    const submit = () => {
        const description = text.trim();
        if (!description || pending.current) return;
        pending.current = true;
        setSubmitting(true);
        apiCall("bmo/betaFeedback", { feedback: description + "\n\n" + "Route: " + returnLocation.route + "\n" + "Controller: " + returnLocation.controller }, (_s, _r) => {
            if (_s) {
                callback(true)
            } else {
                showError(_r);
                callback(false);
            }
            pending.current = false;
            setSubmitting(false);
        }, "bookmanager")


        return;
    };

    return (
        <div
            style={{ width: "min(500px, calc(100vw - 80px))", padding: "0px", }}
            onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Escape") {
                    e.preventDefault();
                    if (!pending.current) {
                        callback(false);
                    }
                }
            }}
        >
            <div className="shim" />  <div className="shim" />
            <Label style={{ "textAlign": "left" }}>
                Describe what happened and what you expected.
            </Label>
            <div className="shim" />

            <TextArea
                ref={(element) => { if (element && !pending.current) { element.focus(); } }}
                value={text}
                onChange={(value) => { if (!pending.current) { setText(value); } }}
                edit
                controlled
                height={200}
                placeholder="What went wrong?"
                style={{ display: "block", width: "100%", boxSizing: "border-box", resize: "vertical", }}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "15px", }} >
                <Button disabled={submitting} onClick={() => callback(false)} >
                    Cancel
                </Button>
                <Button styled type="secondary" disabled={submitting || !text.trim()} onClick={submit} >
                    {submitting ? "Submitting…" : "Submit"}
                </Button>
            </div>
        </div>
    );
}